import React from 'react';
import PropTypes from 'prop-types';
import Iframe from '../shared/Iframe';

const THEMES = {
  light: ['light', '33627'],
  dark: ['dark', '33624'],
};

/**
 * Codepen component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const Codepen = props => {
  const controls = !!props.params.ludus.controls;
  const theme = props.params.ludus.theme || 'light';
  const defaultTab = props.params.ludus.defaultTab || 'result';

  const themeId = THEMES[theme][controls ? 0 : 1];

  const url = `${props.params.ludus.url
    .replace('/pen/', '/embed/')
    .replace('/details/', '/embed/')}?height=${
    props.style.height
  }&embed-version=2&theme-id=${themeId}&editable=true&default-tab=${defaultTab}`;

  return (
    <Iframe
      title="CodePen"
      src={url}
      transitionStatus={props.transitionStatus}
      style={{ ...props.style, opacity: props.groupOpacity }}
      params={props.params}
      applyScaleFix={props.applyScaleFix}
      globalScale={props.globalScale}
      windowHasFocus={props.windowHasFocus}
      groupAngle={props.groupAngle}
      groupScaleX={props.groupScaleX}
      groupScaleY={props.groupScaleY}
      matrixGroup={props.matrixGroup}
      scrolling={false}
    />
  );
};
Codepen.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  applyScaleFix: PropTypes.bool.isRequired,
  globalScale: PropTypes.number.isRequired,
  windowHasFocus: PropTypes.bool.isRequired,
  groupAngle: PropTypes.number.isRequired,
  groupOpacity: PropTypes.number.isRequired,
  groupScaleX: PropTypes.number.isRequired,
  groupScaleY: PropTypes.number.isRequired,
  transitionStatus: PropTypes.string.isRequired,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
};
Codepen.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
};

export default Codepen;
